// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"53565":"ee313c7c","61613":"ee313c7c","76350":"ee313c7c"}[chunkId] + ".chunk.css";
};